export default state => {
	return state.auth.isSigningIn;
};
